import {getManager} from "../../../ts/manager/Manager";
import NavBreadcrumbStructure from "../../partial/structure/NavBreadcrumbStructure";
import React from "react";
import {nbsp} from "../../../ts/common/Constants";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";

const DefaultTitleArea = (props: IRouteProps, withInnerArea?:React.JSX.Element|null) =>
{
    let title = nbsp
    const hidden = getManager().navigation.routeIsProcessing && getManager().ui.primaryViewDidChange;
    if(!hidden){
        const choice = props.choice;
        title = !choice.isUnknown ? choice.name : title;
        let skipNextTitle= false;
        for(let i = getManager().navigation.model.levelList.length - 1; i >= 0; i--){
            const level = getManager().navigation.model.levelList[i];
            const levelChoice = getManager().navigation.model.levelList[i].choice;
            if(!levelChoice){
                continue;
            }
            if(skipNextTitle){
                if(level.model.noTitle){
                    continue;
                }
                title = levelChoice.name;
                break;
            }
            if(levelChoice.id === choice.id){
                if(level.model.noTitle){
                    skipNextTitle = true;
                }
            }
        }
    }

    return <>
        <section className="content-block welcome-block  set-bg-primary mb-0">
            <div className="container h-100 fg">
                <div className="row d-flex align-items-center h-100">
                    <div className="col is-content-area">

                        {!!title &&
                            <h1 className={title.length > 30 ? "reduced" : ""}>
                                {title}
                            </h1>
                        }
                        <NavBreadcrumbStructure {...props} hidden={hidden}/>

                    </div>
                </div>
            </div>
        </section>
    </>;
}
export default DefaultTitleArea;